.overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-drawer);
  background: color-mix(in srgb, var(--ds-slate-975) 55%, transparent);
}

.dialog {
  position: fixed;
  inset: 0;
  margin: auto;
  z-index: var(--z-drawer);
  display: flex;
  width: min(780px, 90dvw);
  height: 475px;
  overflow: hidden;
  border-radius: var(--ds-radius-btn);
  box-shadow: var(--ds-elevation-sm);
  outline: none;
}

.media {
  position: relative;
  flex: 0 0 366px;
  overflow: hidden;
  background: linear-gradient(
    175.2deg,
    var(--ds-grey-700) 34.03%,
    var(--ds-grey-900) 66.41%
  );
}

.illustration {
  position: absolute;
  top: 29px;
  left: 0;
  width: 366px;
  height: 417px;
  object-fit: cover;
  pointer-events: none;
}

.panel {
  display: flex;
  flex: 1 0 0;
  flex-direction: column;
  min-width: 0;
  box-sizing: border-box;
  padding: var(--ds-space-xl);
  background: var(--ds-color-bg-elev-1);
}

.close {
  display: flex;
  justify-content: flex-end;
}

.content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-lg);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-xl);
}

.title {
  composes: text-heading-h1 from global;
  margin: 0;
  color: var(--ds-color-text-hi);
}

.description {
  composes: text-body-1 from global;
  margin: 0;
  color: var(--ds-color-text-default);
}

.actions {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-sm);
  margin-top: auto;
}

.actions > * {
  width: 100%;
}
